import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import { useState } from 'react';

const useStyles = makeStyles((theme) => ({
  disabled: {
    color: theme.palette.text.disabled,
  },
}));

const useTitle = (label) => {
  const [disabled, setDisabled] = useState(false);
  const [suffix, setSuffix] = useState('');
  const classes = useStyles();

  const handleChange = (suffix, disabled) => {
    setDisabled(disabled);
    setSuffix(suffix);
  };

  const title = (
    <Typography
      className={classNames({ [classes.disabled]: disabled })}
      variant="subtitle1"
    >{`${label}${suffix}`}</Typography>
  );

  return [title, handleChange];
};

export default useTitle;
